import { gql } from '@apollo/client';
import { EXPORT_INSTITUTION } from '../../fragments';

export const EXPORT_NSC_PROGRESSION_SCHOOLS = gql`
  query ExportNSCProgressionSchools($input: ExportArgs!) {
    allNSCProgressionSchools(input: $input) {
      ...exportInstitution
    }
  }
  ${EXPORT_INSTITUTION}
`;
